import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { login } from '../../actions/auth';
import anime from 'animejs/lib/anime.es.js';
import HLogo from '../../resources/logos/handdoLogoNew3.png';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const LoginScreen = () => {
    const dispatch = useDispatch();
    const [formValues, setFormValues] = useState();

    if (process.env.NODE_ENV === 'development') {
        cookies.set(
            'token',
            'eyJhbGciOiJIUzI1NiIsImtpZCI6IjZiMWE5MDU4LTgyZDQtNGU1Ny1iMWI0LTBiYjMzYWI1OTRiZCIsInR5cCI6IkJlYXJlciJ9.eyJzdWIiOiIyZGNiNDYzMC04ZDUxLTRiNGUtOGQ4ZC1hMzRlNTg3MDlhYTkiLCJqdGkiOiJiOTEyOGExNi1iODZiLTQ3YzktOGJiNC1lNWNmNjRiYjI0MDkiLCJjdXN0b21lciI6IjFmMjk0MzNlLWYzNmItMTQxMC04MGQ1LTAwZmZmZmZmZmZmZiIsImN1c3RvbWVyX25hbWUiOiJEZW1vIiwicmVhbG0iOiIxZjI5NDMzZS1mMzZiLTE0MTAtODBkNS0wMGZmZmZmZmZmZmYiLCJOYW1lIjoiRGVtbyIsInBlcm1pc3Npb25zIjp7IkRlc2N1ZW50byI6MSwiUHJvZHVjdG8iOjEsIkN1c3RvbWVyIjoxLCJBbG1hY2VuIjoxLCJEb2N1bWVudCI6MSwiTWFuZWphZG9yZXMgZGUgUHJvZHVjdG8iOjEsIk5DRiI6MSwiTcOpdG9kb3MgZGUgUGFnbyI6MSwiSW1wdWVzdG9zIjoxLCJVbmlkYWRlcyBkZSBNZWRpZGEiOjEsIkRlbGl2ZXJ5cyI6MSwiVXN1YXJpb3MiOjEsIkhpc3RvcmljbyBkZSBwcmVjaW8iOjF9LCJuYmYiOjE3NTU2MzAwMTEsImV4cCI6MTc1ODIyMjAxMSwiaWF0IjoxNzU1NjMwMDExLCJpc3MiOiJCaWZyb3N0IiwiYXVkIjoiSGFuZGRvIE1hbmFnZXJzIn0.gJEEuw9cbAogjSJi5TR5cxLL8tj1v_kHmUjdP6SSF_U',
            { path: '/' }
        );
    }

    const handleInputchange = ({ target }) => {
        setFormValues({
            ...formValues,
            [target.id]: target.value,
        });
    };

    const handdleLogin = async (e) => {
        e.preventDefault();
        try {
            dispatch(login(formValues));
        } catch (err) {}
    };

    useEffect(() => {
        let current = null;
        const animateFocus = (offset, array) => {
            if (current) current.pause();
            current = anime({
                targets: 'path',
                strokeDashoffset: { value: offset, duration: 700, easing: 'easeOutQuart' },
                strokeDasharray: { value: array, duration: 700, easing: 'easeOutQuart' },
            });
        };

        document.querySelector('#UserId')?.addEventListener('focus', () => animateFocus(0, '240 1386'));
        document.querySelector('#Password')?.addEventListener('focus', () => animateFocus(-336, '240 1386'));
        document.querySelector('#submit')?.addEventListener('focus', () => animateFocus(-730, '530 1386'));

        document.addEventListener('keypress', (event) => {
            if (event.keyCode === 13) {
                let user = document.getElementById('UserId').value;
                let pass = document.getElementById('Password').value;
                if (user !== '' && pass !== '') animateFocus(-730, '530 1386');
            }
        });
    }, []);

    return (
        <div className="relative min-h-screen bg-gray-100 flex items-center justify-center">
            <div className="absolute top-0 left-0 w-1/2 h-full bg-blue-500" />
            <div className="absolute top-0 right-0 w-1/2 h-full bg-white" />

            <div className="relative z-10 w-full max-w-md p-10 bg-white rounded-lg shadow-xl">
                <div className="flex justify-center mb-6">
                    <img src={HLogo} alt="Handdo Logo" className="h-16" />
                </div>

                <svg className="w-full h-12 mb-4" viewBox="0 0 320 300">
                    <defs>
                        <linearGradient id="linearGradient" x1="13" y1="193.5" x2="307" y2="193.5" gradientUnits="userSpaceOnUse">
                            <stop offset="0" className="text-blue-500" />
                            <stop offset="1" className="text-purple-500" />
                        </linearGradient>
                    </defs>
                    <path className="stroke-current text-blue-500" fill="none" strokeWidth="8" d="m 40,120 240,0 c 0,0 25,0 25,35s-25,35-25,35H40c0,0-25,4-25,38.5S40,267,40,267h215c0,0 20,0 20-25s-20-25-20-25H85c0,0-20,2-20,25s20,25,20,25h169" />
                </svg>

                <form onSubmit={handdleLogin} className="space-y-4">
                    <div>
                        <label htmlFor="UserId" className="block text-sm font-medium text-gray-700">Usuario</label>
                        <input
                            type="text"
                            id="UserId"
                            autoComplete="off"
                            onChange={handleInputchange}
                            required
                            autoFocus
                            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500"
                        />
                    </div>
                    <div>
                        <label htmlFor="Password" className="block text-sm font-medium text-gray-700">Contraseña</label>
                        <input
                            type="password"
                            id="Password"
                            autoComplete="off"
                            onChange={handleInputchange}
                            required
                            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500"
                        />
                    </div>
                    <div>
                        <input
                            type="submit"
                            id="submit"
                            value="Ingresar"
                            className="w-full py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-md shadow"
                        />
                    </div>
                </form>
            </div>
        </div>
    );
};